import type { ReactNode } from 'react';
import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Uitleg bij een kolomkop of label.
 *
 * De prijsopbouw gebruikt begrippen die alleen binnen deze tool bestaan — een
 * "code" is geen productcode maar de naam waarmee formules naar een regel
 * verwijzen. Zonder uitleg ter plekke moet je dat ergens anders opzoeken.
 *
 * Het icoon is een echte button, zodat de uitleg ook met het toetsenbord te
 * bereiken is en niet alleen met de muis.
 */
export function InfoHint({ label, children }: { label: string; children: ReactNode }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={`Uitleg: ${label}`}
          className="inline-flex align-middle text-muted-foreground/70 transition-colors hover:text-foreground focus-visible:text-foreground focus-visible:outline-none"
        >
          <HelpCircle className="h-3.5 w-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs whitespace-normal text-left leading-relaxed">
        {children}
      </TooltipContent>
    </Tooltip>
  );
}

export default InfoHint;
